var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeter = function SvgMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.5 14a.481.481 0 0 1-.487-.5 10 10 0 0 1 19.975 0 .481.481 0 0 1-.488.5h-2a.53.53 0 0 1-.518-.5 7 7 0 0 0-13.964 0 .53.53 0 0 1-.518.5h-2ZM12 14a2 2 0 1 1-1.488-1.934L12.4 9.55l1.2.9-1.887 2.516c.182.302.287.656.287 1.034Z",
    clipRule: "evenodd"
  })));
};
export default SvgMeter;